import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from '../../services/navbar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html'
})
export class AccountComponent implements OnInit, OnDestroy {

  isNavOpen: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(private navBarService: NavbarService) { }

  ngOnInit() {
    this.subscriptions.push(
      this.navBarService.toggleSubject.subscribe(result => {
        if (result != undefined) { this.isNavOpen = result; } else { this.isNavOpen = !this.isNavOpen }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
